import { el } from 'redom';

import SingleSelectOptions from '../options';
import SelectAllButton from './select-all';

import './index.scss';

class OptionsPanel {

  constructor(singleSelectNative, LabelView) {

    this.singleSelectNative = singleSelectNative;
    this.selectAllButton = new SelectAllButton({
      singleSelectNative,
      onChange: this.handleSelectAllStateChange.bind(this)
    });
    this.singleSelectOptions = new SingleSelectOptions(this.singleSelectNative.singleSelectOptionWrapperClass, this.singleSelectNative.singleSelectOptionClass, LabelView, this.singleSelectNative.handleOptionClick.bind(this.singleSelectNative));

    this.el = el('.single-select-options-panel-main.hide-scrollbar', this.renderChildren());

  }

  renderChildren() {

    const children = [];

    if (this.singleSelectNative.multiSelect === true) {
      children.push(this.selectAllButton);
    }

    children.push(this.singleSelectOptions);

    return children;

  }

  handleSelectAllStateChange(allSelected) {

    if (allSelected === true) {
      this.singleSelectNative.selectAllOptions();
    } else {
      this.singleSelectNative.unselectAllOptions();
    }

  }

  update() {

    const singleSelectNative = this.singleSelectNative;

    this.selectAllButton.update();
    this.singleSelectOptions.update(singleSelectNative.options, singleSelectNative);

  }

}

export default OptionsPanel;